import { render, staticRenderFns } from "./genitiv.vue?vue&type=template&id=b36994ae&scoped=true"
import script from "./genitiv.vue?vue&type=script&lang=js"
export * from "./genitiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36994ae",
  null
  
)

export default component.exports